import type { ReactNode } from 'react';
import type { ReportSectionId } from './sectionIds';
import './ReportSection.css';

interface ReportSectionProps {
  /** Doubles as the anchor a reader can link to. */
  id: ReportSectionId;
  number: number;
  title: string;
  /** Prose, not a plain string — ledes carry inline citation markers. */
  lede: ReactNode;
  children: ReactNode;
}

export function ReportSection({ id, number, title, lede, children }: ReportSectionProps) {
  const label = String(number).padStart(2, '0');

  return (
    <section className="ReportSection" id={id}>
      <header className="ReportSection-header">
        {/* The number is the permalink: always visible, so it works on touch
            where a hover-revealed link would never be found. */}
        <a
          className="ReportSection-anchor"
          href={`#${id}`}
          aria-label={`Link to section ${number}: ${title}`}
        >
          {label}
        </a>
        <h3 className="ReportSection-title">{title}</h3>
      </header>
      <p className="ReportSection-lede">{lede}</p>
      {children}
    </section>
  );
}
